module.exports = __webpack_public_path__ + "static/media/Pandas.d721624b.svg";